<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            :hideMoreVert="true"
            :hidePrevious="false"
            @updateProfile="updateProfile()"
        >
            <v-row no-gutters class="d-flex justify-center">
                <v-col cols="8" class="pb-2 text-h6 pl-3"> Taxes </v-col>
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col class="d-flex align-center" style="height: 62px">
                            {{ $t("settings.taxeApprentissage") }}
                        </v-col>
                        <v-col class="d-flex justify-end align-center" style="height: 62px">
                            <v-switch v-model="config.taxeApprentissage" />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col class="d-flex align-center" style="height: 62px">
                            {{ $t("settings.taxeSurLesSalaires") }}
                        </v-col>
                        <v-col class="d-flex justify-end align-center" style="height: 62px">
                            <v-switch v-model="config.taxeSurLesSalaires" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3"> Autres </v-col>
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col class="d-flex align-center" style="height: 62px">
                            {{ $t("settings.contributionUniqueALaFormation") }}
                        </v-col>
                        <v-col class="d-flex justify-end align-center" style="height: 62px">
                            <v-switch v-model="config.contributionUniqueALaFormation" />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col class="d-flex align-center" style="height: 62px">
                            {{ $t("settings.contributionSolidariteAutonomie") }}
                        </v-col>
                        <v-col class="d-flex justify-end align-center" style="height: 62px">
                            <v-switch v-model="config.contributionSolidariteAutonomie" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </setting-card>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const BobbeeImg = require("../../../assets/img/bobbee_mini.png");

@Component({
    components: {
        SettingCard,
    },
    emits: ["updateProfile"],
})
export class Template extends Vue {
    @Prop({}) config!: any;

    get binds() {
        return {
            title: "Taxes & Contributions",
            partnerName: "bobbee",
            text: "Choisissez les taxes et contributions qui concernent votre société. Utiliser pour le dossier de révision",
        };
    }

    updateProfile() {
        this.$emit("updateProfile");
    }
}

export default toNative(Template);
</script>
